import axios, { ResponseType } from "axios";
import { toast } from "react-toastify";
import HelperService from "./HelperService";

const BASE_URL = process.env.REACT_APP_API_BASE_URL

interface PropData {
  action: string;
  body?: any;
  isFormData?: boolean;
  isHideError?: boolean;
  isHideToast?: boolean;
  id?: string;
  _file?: File;
  key?: string;
  btnId?: string;
  responseType?: ResponseType,
  signal?: AbortSignal,
}

let isGlobalErrorShown = false
let globalErrorTimeout: any = null
const WebService = {

  postAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = this.getHeaders()
      WebService.addLoader(props.btnId);
      axios.post(
        `${BASE_URL}${props.action}`,
        props.isFormData ? bodyFormData : props.body,
        { headers }
      )
        .then((response) => {
          resolve(response.data)
          if (!props.isHideToast) {
            toast.success(response.data.message);
          }

        }).catch((error) => {
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          console.log(error);
          props.isHideError
            ? reject(error)
            : reject(WebService.errorHandler(error));
        }).finally(() => {
          WebService.removeLoader(props.btnId);
        })
    });
  },
  downloadFileAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const { body, isFormData, btnId, action } = props;
      const headers = this.getHeaders();
      const bodyFormData = new URLSearchParams();
      if (isFormData) {
        for (let key in body) {
          bodyFormData.append(key, body[key]);
        }
      }
      WebService.addLoader(btnId);
      axios.post(`${BASE_URL}${action}`, isFormData ? bodyFormData : body, {
        headers: {
          ...headers,
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
        .then((response) => {
          WebService.removeLoader(btnId);
          resolve(response.data);
        })
        .catch((error) => {
          WebService.removeLoader(btnId);
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isHideError
            ? reject(error)
            : reject(WebService.errorHandler(error));
        });
    });
  },
  formaDataPostAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const bodyFormData = new FormData();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = this.getMultipartHeaders()
      WebService.addLoader(props.btnId);
      axios.post(
        `${BASE_URL}${props.action}`,
        props.isFormData ? bodyFormData : props.body,
        { headers }
      )
        .then((response) => {
          resolve(response.data)
          if (!props.isHideToast) {
            toast.success(response.data.message);
          }
          WebService.removeLoader(props.btnId);
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          WebService.removeLoader(props.btnId);
          props.isHideError
            ? reject(error)
            : reject(WebService.errorHandler(error));
        });
    });
  },
  formaDataPutAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const bodyFormData = new FormData();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = this.getMultipartHeaders();
      WebService.addLoader(props.btnId);
      axios.put(
        `${BASE_URL}${props.action}`,
        props.isFormData ? bodyFormData : props.body,
        { headers }
      )
        .then((response) => {
          resolve(response.data)
          if (!props.isHideToast) {
            toast.success(response.data.message);
          }
          WebService.removeLoader(props.btnId);
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          WebService.removeLoader(props.btnId);
          props.isHideError
            ? reject(error)
            : reject(WebService.errorHandler(error));
        });
    });
  },
  uploadAPI(props: PropData) {
    let formData = new FormData();
    if (props._file && props.key) {
      formData.append(props.key, props._file);
    }
    return new Promise((resolve, reject) => {
      for (let key in props.body) {
        formData.append(key, props.body[key]);
      }
      const headers = this.getMultipartHeaders();
      axios.post(`${BASE_URL}${props.action}`, formData, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => {
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isHideError
            ? reject(WebService.errorHandler(error))
            : reject(error);
        });
    });
  },

  putAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = this.getHeaders();
      if (props.btnId) {
        WebService.addLoader(props.btnId);
      }
      axios
        .put(`${BASE_URL}${props.action}`, props.body, { headers })
        .then((response) => {
          if (props.btnId) {
            WebService.removeLoader(props.btnId);
          }
          if (!props.isHideToast) {
            toast.success(response.data.message);
          }
          resolve(response.data)
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          if (props.btnId) {
            WebService.removeLoader(props.btnId);
          }
          props.isHideError
            ? reject(error)
            : reject(WebService.errorHandler(error))
        });
    });
  },

  beforeLoginAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/json",
      };
      if (props.btnId) {
        WebService.addLoader(props.btnId);
      }
      axios
        .post(
          `${BASE_URL}${props.action}`,
          props.isFormData ? bodyFormData : props.body,
          { headers }
        )
        .then((response) => {
          resolve(response.data)
          if (!props.isHideToast) {
            toast.success(response.data.message);
          }
          if (props.btnId) {
            WebService.removeLoader(props.btnId);
          }
        })
        .catch((error) => {
          if (props.btnId) {
            WebService.removeLoader(props.btnId);
          }
          if (props.isHideError) {
            reject(WebService.errorHandler(error));
          } else {
            toast.error(error?.response?.data?.message);
            reject(error);
          }
        });
    });
  },
  beforeLoginPutAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/json",
      };
      if (props.btnId) {
        WebService.addLoader(props.btnId);
      }
      axios
        .put(
          `${BASE_URL}${props.action}`,
          props.isFormData ? bodyFormData : props.body,
          { headers }
        )
        .then((response) => {
          resolve(response.data)
          if (!props.isHideToast) {
            toast.success(response.data.message);
          }
          if (props.btnId) {
            WebService.removeLoader(props.btnId);
          }
        })
        .catch((error) => {
          if (props.btnId) {
            WebService.removeLoader(props.btnId);
          }
          if (props.isHideError) {
            reject(WebService.errorHandler(error));
          } else {
            toast.error(error?.response?.data?.message);
            reject(error);
          }
        });
    });
  },

  getAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = this.getHeaders();
      if (props.responseType === 'blob' || props.responseType === 'arraybuffer') {
        headers['Accept'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      }
      if (props.btnId) {
        WebService.addLoader(props.btnId);
      }

      axios
        .get(`${BASE_URL}${props.action}`, {
          headers,
          responseType: props.responseType || 'json', // ✅ allow 'blob' for downloads
          signal: props.signal
        })
        .then((response) => {
          if (props.btnId) {
            WebService.removeLoader(props.btnId);
          }

          // ✅ If it's a file (blob), resolve the full response
          if (props.responseType === 'arraybuffer' || props.responseType === 'blob') {
            resolve(response); // send full response for file metadata
          } else {
            resolve(response.data);
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            return reject(error);
          }
          if (props.btnId) {
            WebService.removeLoader(props.btnId);
          }
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isHideError
            ? reject(error)
            : reject(WebService.errorHandler(error));
        });
    });
  },

  deleteAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = this.getHeaders();
      if (props.btnId) {
        WebService.addLoader(props.btnId);
      }
      axios.delete(`${BASE_URL}${props.action}`, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => {
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isHideError
            ? reject(error) : reject(WebService.errorHandler(error))
        });
    }).finally(() => {
      if (props.btnId) {
        WebService.removeLoader(props.btnId);
      }
    })
  },

  errorHandler(error: any) {
    if (error?.response) {
      error = error.response;
    }
    let errorMessage;
    if (!error || !error.status) {
      errorMessage = "Server Not Responding";
    } else if (error.status === 401) {
      errorMessage = "Unauthorized";
      WebService.logout();
    } else if (error.status === 500) {
      errorMessage =
        error?.data?.ErrorDetails?.message ||
        "An unknown exception has occurred. Please contact administrator";
    } else {
      errorMessage = error.data?.message || "Something went wrong";
    }
    const isGlobalIssue =
      !error?.status || error?.status >= 500 || error?.status === 0;

    if (isGlobalIssue) {
      if (!isGlobalErrorShown) {
        isGlobalErrorShown = true;
        // toast.error(errorMessage);
        HelperService.showSingleError(errorMessage);
        // reset after 5 seconds so new errors can show later
        globalErrorTimeout = setTimeout(() => {
          isGlobalErrorShown = false;
        }, 5000);
      }
    } else {
      // toast.error(errorMessage);
      HelperService.showSingleError(errorMessage);
    }
    return errorMessage;
  },


  addLoader(id?: string) {
    if (!id) return;

    const button = document.getElementById(id) as HTMLButtonElement | null;
    if (!button) return;

    button.disabled = true;
    button.style.position = "relative"; // make button the positioning context

    // Create loader wrapper
    const loader = document.createElement("span");
    loader.className = "button-loader";
    loader.innerHTML = `
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  `;

    // Style loader to center it
    Object.assign(loader.style, {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-70%, -70%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      pointerEvents: "none",
      color: '#931314'
    });

    button.appendChild(loader);
  },


  removeLoader(id: any) {
    if (!id) return;

    const button = document.getElementById(id) as HTMLButtonElement | null;
    if (!button) return;

    button.disabled = false;

    // Find the loader element we added
    const loader = button.querySelector(".button-loader");
    if (loader) {
      button.removeChild(loader);
    }
  },



  logout() {
    window.location.href = "/login";
    localStorage.clear();
  },
  getBaseUrl() {
    return BASE_URL;
  },
  getHeaders(): Record<string, string> {
    return {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      outletid: localStorage.getItem("outlet_id") || '',
      clientid: localStorage.getItem("client_id") || '',
      tableid: localStorage.getItem("table_id") || '',
    };
  },
  getMultipartHeaders() {
    const headers = {
      // "Content-Type": "application/x-www-form-urlencoded",
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      outletid: localStorage.getItem("outlet_id") || '',
      clientid: localStorage.getItem("client_id") || '',
      tableid: localStorage.getItem("table_id") || '',
    };
    return headers;
  },
};

export default WebService;
